import { ApocalypseFreespinWinPresentation } from "../freespin/ApocalypseFreespinWinPresentation";

export class ApocalypseSuperFreespinWinPresentation extends ApocalypseFreespinWinPresentation {
    constructor() {
        super(`ApocalypseSuperFreespinWinPresentation`);
    }
}
